import React from 'react';
import { Box, CircularProgress, LinearProgress } from '@mui/material';

/**
 * Könnyű betöltésjelző a lusta (lazy) oldalakhoz: vékony csík a tartalom tetején
 * és egy kis pörgettyű középen. Rövid késleltetéssel jelenik meg, így gyors
 * betöltésnél nem villan fel.
 */
const PageLoader: React.FC = () => (
  <Box
    role="status"
    aria-label="Oldal betöltése"
    data-testid="page-loader"
    sx={{
      position: 'relative',
      minHeight: '40vh',
      animation: 'kmPageLoaderFadeIn 0.2s ease 0.15s both',
      '@keyframes kmPageLoaderFadeIn': {
        from: { opacity: 0 },
        to: { opacity: 1 },
      },
    }}
  >
    <LinearProgress
      color="primary"
      sx={{ position: 'absolute', top: 0, left: 0, right: 0, height: 3 }}
      aria-hidden
    />
    <Box sx={{ display: 'flex', justifyContent: 'center', pt: 8 }}>
      <CircularProgress size={32} thickness={4} aria-hidden />
    </Box>
  </Box>
);

export default PageLoader;
